var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPromoText = function SvgPromoText(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8083 5.38889L16.8333 9.95056V18.6111H5.16667V5.38889H12.8083ZM12.8083 3.5H5.16667C4.25 3.5 3.5 4.35 3.5 5.38889V18.6111C3.5 19.65 4.25 20.5 5.16667 20.5H16.8333C17.75 20.5 18.5 19.65 18.5 18.6111V9.95056C18.5 9.45 18.325 8.96833 18.0083 8.61889L13.9833 4.05722C13.675 3.69833 13.25 3.5 12.8083 3.5ZM6.83333 15.1935H15.1667V16.7222H6.83333V15.1935ZM6.83333 11.4736H15.1667V12.9444H6.83333V11.4736ZM6.83333 7.60963H12.6667V9.16667H6.83333V7.60963Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPromoText);
export default ForwardRef;